import { setFireBaseState } from "store/app.slice";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "store/store";
import { firebaseCollections } from "globals/enums";
import { getDatabase, onValue, ref } from "firebase/database";

const useWatchSecondaryDisabled = () => {
  const session = useAppSelector((state) => state.app.session);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!session.session_id) return;

    const streamingRef = ref(
      getDatabase(),
      `${firebaseCollections.Session}/${session.session_id}/streaming_device`
    );
    const unsubscribe = onValue(streamingRef, (streamingSnapShot) => {
      const isSecondaryCameraDisabled = streamingSnapShot.val() || {};
      dispatch(
        setFireBaseState({
          is_secondary_disabled: isSecondaryCameraDisabled.is_secondary_disabled || false
        })
      );
    });

    return () => {
      unsubscribe();
    };
  }, [session.session_id, dispatch]);

  return null;
};

export default useWatchSecondaryDisabled;
